<template>
  <div class="img-dialog" v-show="value"  @click="handleAction('confirm')">
    <img :src="img" />
  </div>
</template>
<script>
import { createNamespace, isDef } from "vant/lib/utils";
import { PopupMixin } from "vant/lib/mixins/popup";
const [createComponent, bem] = createNamespace("popup");

  export default createComponent({
    name: 'ImgDialog',

    components: {},

    mixins: [PopupMixin],

    props: {
      callback: Function,
      overlay: {
        type: Boolean,
        default: true
      },
      closeOnClickOverlay: {
        type: Boolean,
        default: false
      },
      lockOnScroll: {
        type: Boolean,
        default: true
      },
      img: {
        type: String,
        default: 'https://vipcdn.mgtv.com/upload3/201812/1207/share2.png'
      },
    },
    methods: {
      handleAction(action) {
        this.$emit('input', false);
        this.$emit(action);
        this.callback && this.callback(action);
      }
    },
    computed: {

    }
  });
</script>


<style lang="stylus" scoped>

  .img-dialog
    position: fixed;
    top: 0;
    right: 0;
    transition: .2s;
    display: flex
    justify-content: space-around
    align-items: center
    height: 100%
    width: 100%
    img
      max-width 6rem
</style>
